import { REMOVE_GIFT_CODE } from "./actionTypes";

export default () => ({
  type: REMOVE_GIFT_CODE,
  payload: {}
});